import { render, staticRenderFns } from "./Reorden.vue?vue&type=template&id=3ca5a323&"
import script from "./Reorden.vue?vue&type=script&lang=js&"
export * from "./Reorden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports